<template>
  <b-container fluid>
    <b-row>
      <b-col lg="6"  v-for="(item,index) in gettFaqAllActive"
            :key="index"
            :class="(item.active == 0) ? 'accordion-active' : ''">
        <div class="iq-accordion career-style faq-style">
          <iq-card
            class="iq-card iq-accordion-block"
          >
            <div class="clearfix" :class="(item.active == 0) ? 'active-faq' : ''">
              <div class="container">
                <b-row class="py-2">
                  <b-col sm="12">
                    <a class="accordion-title">
                      <span class="text-primary">{{ item.title }}</span>
                    </a>
                  </b-col>
                </b-row>
              </div>
            </div>
            <div class="accordion-details">
              <p class="mb-0" v-html="item.description"></p>
            </div>
          </iq-card>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'FAQ',
  mounted () {
    findash.index()
  },
  data () {
    return {

    }
  },
  computed:{
      ...mapGetters([
        'gettFaqAllActive',
        ]),
  },
  methods:{
    ...mapActions([
       'fetchFaqAllActive',
    ]),
  },
  created(){
      this.fetchFaqAllActive();
  }
}
</script>
